export function initCategorySearch() {
    const searchBtn = document.getElementById('category-search-btn');
    const dropdown = document.getElementById('dropdown');
    const errorMsg = document.querySelector('.dropdown-error-message');
  
    // Hide error message initially
    if (errorMsg) {
      errorMsg.style.display = 'none';
    }
  
    if (searchBtn && dropdown && errorMsg) {
      searchBtn.addEventListener('click', function (e) {
        e.preventDefault();
        const selectedSlug = dropdown.value.trim();

        // Remove previous error
        dropdown.classList.remove('has-error');
        errorMsg.style.display = 'none';
        
        if (selectedSlug === '') {
            // Nothing selected
            dropdown.classList.add('has-error');
            errorMsg.style.display = 'block';
        } else if (selectedSlug === 'all') {
            // Redirect to blog home
            window.location.href = blogData.siteUrl; // or siteUrl
        } else {
            // Redirect to selected category
            window.location.href = blogData.siteUrl + 'category/' + selectedSlug + '/';
        }
      });
  
      // Remove error highlights immediately when user selects a category
      dropdown.addEventListener('change', function () {
        if (dropdown.value !== '') {
          dropdown.classList.remove('has-error');
          errorMsg.style.display = 'none';
        }
      });
    }
  }
  